import React from 'react';
import ReactCountryFlag from 'react-country-flag';

const Header = ({ language, onToggleLanguage }) => {
  const texts = {
    en: {
      logo: 'CookingAI365',
      nav: ['Home', 'Features', 'How it works', 'Benefits'],
      cta: 'Try it now'
    },
    pt: {
      logo: 'CookingAI365',
      nav: ['Início', 'Recursos', 'Como funciona', 'Benefícios'],
      cta: 'Experimente agora'
    }
  };

  const t = texts[language];

  return (
    <header className="bg-white shadow-lg sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-4">
          <div className="flex items-center">
            <h1 className="text-2xl font-bold text-green-600">{t.logo}</h1>
          </div>
          
          <nav className="hidden md:flex space-x-8">
            {t.nav.map((item, index) => (
              <a
                key={index}
                href={`#section-${index + 1}`}
                className="text-gray-700 hover:text-green-600 transition-colors duration-200"
              >
                {item}
              </a>
            ))}
          </nav>

          <div className="flex items-center space-x-4">
            <button
              onClick={onToggleLanguage}
              className="flex items-center space-x-2 px-3 py-2 rounded-lg bg-gray-100 hover:bg-gray-200 transition-colors duration-200"
            >
              <ReactCountryFlag countryCode={language === 'en' ? 'PT' : 'GB'} svg className="w-6 h-4" />
              <span className="text-sm font-medium">
                {language === 'en' ? 'Português' : 'English'}
              </span>
            </button>
            
            <a href="/s" className="bg-green-600 text-white px-6 py-2 rounded-lg hover:bg-green-700 transition-colors duration-200 font-medium inline-block">
              {t.cta}
            </a>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;
